export enum UserRole {
  ADMIN = 'admin',
  SUPER_ADMIN = 'super_admin',
  MANAGER = 'manager',
  ACCOUNTANT = 'accountant',
  ACCOUNTING_MANAGER = 'accounting_manager', // Backend role name
  MODERATOR = 'moderator',
  MARKETER = 'market_developer',  // ممنوع من لوحة التحكم (role id = 2)
  PROVIDER = 'provider',          // مزود الخدمة (role id = 3)
  STORE = 'store',
  SERVICE_PROVIDER = 'provider'   // Use existing 'provider' role for service providers
}

// الأدوار المسموحة بالوصول للوحة التحكم
export const DASHBOARD_ALLOWED_ROLES = [
  UserRole.ADMIN,
  UserRole.SUPER_ADMIN,
  UserRole.MANAGER,
  UserRole.ACCOUNTANT,
  UserRole.ACCOUNTING_MANAGER, // Allow accounting managers
  UserRole.MODERATOR,
  UserRole.SERVICE_PROVIDER  // Allow service providers to access dashboard
  // UserRole.PROVIDER,  // أضف إذا كان مسموح
  // UserRole.STORE,     // أضف إذا كان مسموح
];

// الأدوار الممنوعة من لوحة التحكم
export const DASHBOARD_BLOCKED_ROLES = [
  UserRole.MARKETER  // market_developer (role id = 2)
];
